import { FC } from "react";
import { Balance } from "../../../components/StatsPanel/Balance/Balance";
import { Tickets } from "../../../components/TicketsPanel/Tickets";
import { useSelector } from "../../../hooks";
import currencyIcon from "../../../icons/currency.png";
import styles from "./GameBalances.module.scss";
import { shortNumberForm } from "../../../utils/numbers";
import { ITicketsBalances } from "../../../model/user-info.interface";

export type WheelGameFrozenWallet = {
    balance: number;
    tickets: ITicketsBalances;
};

interface IGameBalancesProps {
    /** Пока не остановилось колесо — показываем снимок до начисления (в сторе уже updatedBalance) */
    freezeWallet?: WheelGameFrozenWallet | null;
}

export const GameBalances: FC<IGameBalancesProps> = ({ freezeWallet }) => {
    const { tickets } = useSelector(store => store.user.info);

    const shownTickets = freezeWallet?.tickets ?? tickets;

    return (
        <div className={styles.container}>
            <div className={styles.bottomRow}>
                <div className={styles.balance}>
                    <img src={currencyIcon} className={styles.icon} alt="balace currency" />
                    {freezeWallet ? (
                        <span>
                            {shortNumberForm(Math.round(freezeWallet.balance), 1)}
                        </span>
                    ) : (
                        <Balance />
                    )}
                </div>
            </div>

            <Tickets regularTickets={shownTickets.regularTickets} rareTickets={shownTickets.rareTickets} context='header' precission={2} />
            <Tickets epicTickets={shownTickets.epicTickets} legendaryTickets={shownTickets.legendaryTickets} context='header' precission={2} />
        </div>
    );
};
